import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>Sissejuhatus</Summary>
        <Details>
          <p>
            Selle privaatsusteate (edaspidi „teade“) on PlusPlus Grupi (edaspidi
            „PlusPlus“) nimel väljastanud PlusPlus Baltic OÜ ja selles
            teavitatakse teid sellest, kuidas PlusPlus teie isikuandmeid töötleb
            ning millised on teie isikuandmete kaitsega seotud õigused.
            Käesolevas teates kasutatavad mõisted on määratletud isikuandmete
            kaitse üldmääruses (edaspidi „üldmäärus“) ja kehtivates
            õigusaktides.
          </p>
          <p>&nbsp;</p>
          <p>
            See teade on adresseeritud füüsilisele isikule, kellelt või kelle
            kohta me oma teenuste osutamise või muul moel oma majandustegevuse
            käigus isikuandmeid kogume või saame (edaspidi „teie“ või
            „andmesubjekt“).
          </p>
          <p>&nbsp;</p>
          <p>
            PlusPlus Grupp koosneb erinevatest juriidilistest isikutest ja
            olenevalt asjaoludest võib asjaomane PlusPlusi ettevõte tegutseda
            teie andmete vastutava töötlejana (edaspidi „meie“ või „vastutav
            töötleja“). Vastutavate töötlejate kontaktandmed leiate teate
            lõpust. PlusPlus Grupi ettevõtete omavahelised suhted andmete
            töötlemisel on määratletud nende vahel sõlmitud kokkulepetes.
          </p>
          <p>&nbsp;</p>
          <p>
            Esmane kontakt teie isikuandmete töötlemist puudutavate mis tahes
            küsimuste või käesoleva teatega seoses või teabe saamiseks on meie
            andmekaitsespetsialist e-posti aadressil:
            privacy[at]pluspluscapital.eu.
          </p>
          <p>&nbsp;</p>
          <p>
            Teates tehtavad mis tahes olulised muudatused postitame oma
            veebisaidile ja vajadusel teavitame teid muudatusest e-posti teel.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Milliseid andmeid me teie kohta kogume?</Summary>
        <Details>
          <p>
            Me võime teie kohta koguda, säilitada, kasutada, edastada ja muul
            viisil töödelda erinevaid isikuandmeid, mida võib jagada
            järgmistesse gruppidesse:
          </p>
          <p>&nbsp;</p>
          <ul>
            <li>kontaktandmed (aadress, e-posti aadress, telefon jms);</li>
            <li>
              andmed isiku tuvastamiseks (nimi, isikukood, sünnikuupäev ja
              -koht, rahvus, isikut tõendava dokumendi andmed jms);
            </li>
            <li>
              andmed töötamise kohta (praegune tööandja ja varasemad töökohad,
              ametinimetus jms);
            </li>
            <li>
              lepingu- ja tehinguandmed (PlusPlusi omandatud nõuete või
              lepingute andmed ja vastavates dokumentides sisalduvad andmed,
              pangakonto number, sissetuleku andmed ja vara andmed, PlusPlusi
              omandatud nõuete või lepingutega seotud maksete ajalugu,
              maksehäirete andmed, andmed PlusPlusi omandatud nõuete või
              lepingutega seotud teiste isikute (nt käendajad, kaaslaenusaajad,
              tagatise andjad) kohta jms);
            </li>
            <li>IP-aadress ja analüütikaandmed.</li>
          </ul>
          <p>&nbsp;</p>
          <p>
            IP-aadress on kordumatu numbriline aadress, mis määratakse arvutile
            selle internetiga ühendumisel. Teie IP-aadress salvestatakse logis,
            kui kasutate meie veebisaidil pakutavat chat-suhtluse võimalust.
            IP-aadressi kasutatakse tehnilisel eesmärgil, et tagada meie
            veebisaidi toimimine ja turvalisus.
          </p>
          <p>
            Me kasutame Google Analyticsi tööriista teatud mitteisikuliste
            andmete salvestamiseks, et saada teavet selle kohta, kuidas
            külastajad meie veebisaiti kasutavad (veebisaidi kasutamise aeg,
            kasutatav veebilehitseja ja seade, külastajate asukoha piirkond ja
            muu sarnane statistika), et saaksime vastavalt oma veebisaiti
            täiustada. Google Analyticsi kohta leiate lähemat infot aadressil:{" "}
            <a
              href="https://support.google.com/analytics/#topic=10737980"
              target="_blank"
            >
              https://support.google.com/analytics/#topic=10737980.
            </a>
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Millistest allikatest teie isikuandmeid kogutakse?</Summary>
        <Details>
          <ul>
            <li>
              Kolmandatelt isikutelt (sh avalikult ligipääsetavatest allikatest)
              nagu PlusPlusi omandatud nõuete või lepingute müüjad (st algsed
              võlausaldajad), nõude või lepinguga seotud isikud (nt käendajad,
              kaaslaenusaajad, tagatise andjad jne), ametiasutused (kohtud,
              kohtutäiturid, pankrotihaldurid jne), asjakohaste elektrooniliste
              andmebaaside, mida peavad kolmandast isikust teenusepakkujad,
              otsingute kaudu (maksehäirete register, kinnistusraamat,
              äriregister jne) ning muud avalikult ligipääsetavad allikad ja
              otsingumootorid
            </li>
            <li>PlusPlus Grupi äriühingutelt</li>
            <li>
              Teilt – teatud isikuandmeid võime saada teilt otse telefoni või
              e-posti teel või muul viisil teiega suheldes (teie poolt
              iseteeninduses täidetavad vormid, meievaheline teabevahetus ja
              erinevad õiguslikud menetlused jne)
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Kuidas me teie isikuandmeid kasutame (töötleme)?</Summary>
        <Details>
          <p>
            Töötleme teie isikuandmeid konkreetsetel eesmärkidel ning kooskõlas
            üldmääruse ja kehtivate õigusaktidega.
          </p>
          <p>&nbsp;</p>
          <p>
            Peamised eesmärgid, milleks me teie andmeid töötleme, ja sellise
            töötlemise õiguslikud alused on järgmised:
          </p>
          <p>&nbsp;</p>
          <ul>
            <li>
              üldmääruse artikkel 6 (1) (b) - lepingu täitmine, mille pooleks te
              olete, või lepingu või muu kokkuleppe sõlmimiseks sammude
              astumine, näiteks järgmised toimingud:
              <ul>
                <li>
                  teie andmete sisestamine asjaomastesse registritesse
                  taustauuringu tegemiseks ja PlusPlusi nõude täitmiseks;
                </li>
                <li>teie isikuandmete sisestamine meie infosüsteemidesse;</li>
                <li>
                  nõude, mis PlusPlusil on teie või teise asjassepuutuva isiku
                  vastu, käsitlemine ja/või sissenõudmine (vastavalt asjaoludele
                  kas teie või kolmandate isikutega suheldes või muid toiminguid
                  tehes, et asjaomane nõue täita);
                </li>
              </ul>
            </li>
          </ul>
          <ul>
            <li>
              üldmääruse artikkel 6 (1) (c) - õigusliku või regulatiivse
              kohustuse täitmise vajadus, näiteks:
              <ul>
                <li>PlusPlusi raamatupidamine ja auditeerimine;</li>
              </ul>
            </li>
          </ul>
          <ul>
            <li>
              üldmääruse artikkel 6 (1) (f) - vajalik meie õigustatud huvi
              korral (meie äritegevuse läbiviimine), kui andmesubjekti huvid või
              põhiõigused ja -vabadused ei kaalu sellist huvi üles, näiteks:
              <ul>
                <li>
                  meie ettevõttesisene ärialane aruandlus ja teabevahetus;
                </li>
                <li>
                  teile nõu andmine seoses teie PlusPlusi ees olevate kohustuste
                  efektiivse täitmisega;
                </li>
                <li>
                  meie IT-süsteemide, veebilehtede ja iseteenindussüsteemide
                  arendamine.
                </li>
              </ul>
            </li>
            <li>
              üldmääruse artikkel 6 (1) (a) - eesmärkidel, mis olid välja toodud
              teilt nõusoleku saamisel, juhul kui olete andnud nõusoleku teie
              isikuandmete töötlemiseks.
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Teie isikuandmete avaldamine</Summary>
        <Details>
          <p>
            Me võime jagada teie isikuandmeid kolmandate isikutega, kes osutavad
            meile meie majandustegevuseks vajalikke teenuseid või keda
            kaasatakse nõude, mis PlusPlusil on teie või teise asjassepuutuva
            isiku vastu, käsitlus- ja/või sissenõudmisprotsessi (vt töötlemise
            eesmärkide liigitust eespool).
          </p>
          <p>&nbsp;</p>
          <p>
            Me nõuame kolmandatest isikutest teenusepakkujatelt, et nad tagaksid
            teie andmete turvalisuse ja töötleksid neid andmeid meie juhiste
            kohaselt ja kooskõlas käesoleva teate, üldmääruse ja kehtivate
            õigusaktidest tulenevate nõuetega. Need kolmandad isikud võivad
            kasutada teie isikuandmeid üksnes konkreetsetel eesmärkidel
            vastavalt teenustele, mida nad meile osutavad.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Edastamine väljaspoole EMP-d</Summary>
        <Details>
          <p>
            Meie majandustegevuse käigus võidakse teie isikuandmed edastada ja
            neid võivad töödelda väljaspool Euroopa Majanduspiirkonda (edaspidi
            „EMP“) asuvad saajad. Näiteks võivad mõne meie kolmandast isikust
            teenusepakkuja andmeserverid asuda väljaspool EMP-d.
          </p>
          <p>&nbsp;</p>
          <p>
            PlusPlus rakendab meetmeid, et tagada väljapoole EMP-d edastatamisel
            piisav kaitse vastavalt käesolevale teatele, üldmäärusele ja
            kehtivatele õigusaktidele. Riikide puhul, kus ei ole tagatud piisav
            andmekaitse tase, tugineme edastusel asjaomastele
            kaitsemehhanismidele, nagu Euroopa Komisjoni poolt kinnitatud
            standardsed andmekaitsesätted või heakskiidetud
            sertifitseerimismehhanismidele koos andmete saajale siduvate ja
            jõustatavate kohustustega. Isikuandmete edastamisel Ameerika
            Ühendriikidesse võib saaja olla liitunud ELi-USA
            andmekaitseraamistikuga <em>Privacy Shield</em> ja seega olla
            tunnustatud kui piisava andmekaitse taseme tagaja, mis teeb
            võimalikuks andmete edastamise EList USAsse.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Teie isikuandmete säilitamine ja turvalisus </Summary>
        <Details>
          <p>
            Me töötleme teie isikuandmeid lepingu või muu kokkuleppe täitmise
            ajal ning säilitame seejärel teie isikuandmeid seni, kuni see on
            vajalik selle eesmärgi täitmiseks, milleks me neid kogusime, kaasa
            arvatud meie suhtes kohalduvate õiguslike, maksualaste või
            raamatupidamiskohustuste täitmiseks.
          </p>
          <p>&nbsp;</p>
          <p>
            Lepingute ja/või tehingutega seotud isikuandmed on osa meie
            raamatupidamise ja majandustegevuse dokumentatsioonist ning neid
            säilitatakse 10 aastat alates nende kirjendamise aasta lõpust.
            Säilitusperiood võib olla pikem, kui teie isikuandmete töötlemine on
            nõutav muude meie põhitegevusega seotud nõuete täitmiseks (näiteks
            nõude esitamiseks või täitmiseks). Kui säilitusperiood on lõppenud,
            kustutame isikuandmed või muudame need anonüümseks.
          </p>
          <p>&nbsp;</p>
          <p>
            Me säilitame mitteisikulisi ja statistilisi andmeid meie
            veebisaitide kasutamise kohta 3 aastat.
          </p>
          <p>&nbsp;</p>
          <p>
            Me oleme rakendanud üldiselt aktsepteeritud tehnoloogilisi ja
            operatsioonilisi turvalisuse standardeid, et kaitsta teie
            isikuandmeid kaotsimineku, väärkasutuse, muutmise või hävitamise
            eest. Nõuame kõigilt oma töötajatelt isikuandmete
            konfidentsiaalsusnõude järgimist ning sellistele andmetele on
            juurdepääs ainult selleks volitatud isikutel.
          </p>
          <p>&nbsp;</p>
          <p>
            Astume samme selleks, et tagada asjakohaste turvameetmete
            rakendamine teie isikuandmete kaitsega seotud õiguste jätkuvaks
            kaitseks.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Teie õigused</Summary>
        <Details>
          <p>
            Teil on seoses oma isikuandmetega, mida töötleme, erinevaid õigusi:
          </p>
          <p>&nbsp;</p>
          <ul>
            <li>
              <strong>õigus taotleda ligipääsu:</strong> teil on õigus taotleda
              meilt kinnitust selle kohta, millist informatsiooni me teie osas
              mis tahes ajahetkel töötleme. Me ei pruugi õiguslikel põhjustel
              alati olla kohustatud teie taotlust täitma. Kui keeldume teie
              taotluse täitmisest, teavitame teid keeldumise põhjustest;
            </li>
            <li>
              <strong>õigus andmete parandamisele:</strong> teil on õigus nõuda,
              et me parandaksime teie mis tahes ebatäpsed või mittetäielikud
              isikuandmed, mida töötleme. Kui oleme jaganud selliseid
              isikuandmeid kolmandate isikutega, teavitame neid parandamisest,
              välja arvatud juhul, kui see on võimatu või see eeldaks
              ebaproportsionaalseid jõupingutusi. Me ei pruugi õiguslikel
              põhjustel alati olla kohustatud teie taotlust täitma. Kui keeldume
              teie taotluse täitmisest, teavitame teid keeldumise põhjustest;
            </li>
            <li>
              <strong>õigus andmete kustutamisele:</strong> teatud asjaoludel on
              teil õigus nõuda, et kustutaksime teie isikuandmed. Me ei pruugi
              õiguslikel põhjustel alati olla kohustatud teie taotlust täitma.
              Kui keeldume teie taotluse täitmisest, teavitame teid keeldumise
              põhjustest;
            </li>
            <li>
              <strong>õigus isikuandmete töötlemise piiramisele:</strong> teatud
              asjaoludel on teil õigus nõuda, et piiraksime teie isikuandmete
              töötlemist. See tähendab, et võime üksnes teie isikuandmeid
              säilitada ja ei või andmeid töödelda muul viisil. Me ei pruugi
              õiguslikel põhjustel alati olla kohustatud teie taotlust täitma.
              Kui keeldume teie taotluse täitmisest, teavitame teid keeldumise
              põhjustest;
            </li>
            <li>
              <strong>õigus esitada vastuväiteid:</strong> teatud asjaoludel on
              teil õigus esitada vastuväiteid teie isikuandmete töötlemise
              suhtes. Me ei pruugi õiguslikel põhjustel alati olla kohustatud
              teie taotlust täitma. Kui keeldume teie taotluse täitmisest,
              teavitame teid keeldumise põhjustest;
            </li>
            <li>
              <strong>andmete ülekandmise õigus:</strong> teil on õigus edastada
              isikuandmeid erinevate vastutavate töötlejate vahel, arvestades
              seejuures kohalduvatest õigusaktidest tulenevaid võimalikke
              piiranguid. See tähendab, et saate edastada andmeid, mida teie
              suhtes töötleme, erinevatele teenusepakkujtele või kolmandatele
              osapooltele. Esitame teie andmed üldkasutatavas vormingus ning
              masinloetaval kujul, et saaksite andmed edastada;
            </li>
            <li>
              <strong>
                õigus mitte olla üksnes automatiseeritud töötlusel põhineva
                otsuse subjektiks:
              </strong>
              teil on õigus mitte olla otsuse subjektiks, mis põhineb üksnes
              automatiseeritud töötlusel, sealhulgas profiilianalüüsil, mis toob
              kaasa teid puudutavaid õiguslikke tagajärgi või avaldab teile
              sarnast mõju. Kohalduvatest õigusaktidest võib tulla piiranguid
              selle õiguse teostamisele. Me ei pruugi õiguslikel põhjustel alati
              olla kohustatud teie taotlust täitma. Kui keeldume teie taotluse
              täitmisest, teavitame teid keeldumise põhjustest.
            </li>
          </ul>
          <p>&nbsp;</p>
          <p>
            Teil on õigus kasutada oma õigusi kooskõlas üldmääruse ja kehtivate
            õigusaktide nõuetega.
          </p>
          <p>&nbsp;</p>
          <p>
            Oma õiguste kasutamiseks võtke palun meiega ühendust e-posti
            aadressil privacy[at]pluspluscapital.eu. Teie isikuandmete
            töötlemisega seonduvate õiguste kohta teabe vahetamisel võib meil
            olla vaja küsida teilt teie isiku tuvastamiseks teatud teavet või
            dokumente. See on vajalik, et tagada, et isikuandmeid ei avaldata
            ühelegi isikule, kelleks ei ole teie või kellel ei ole õigust teie
            isikuandmeid saada.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Kaebuse esitamise õigus</Summary>
        <Details>
          <p>
            Kui leiate, et teie isikuandmete töötlemise alaseid õigusi on
            rikutud, on teil õigus esitada kaebus selle riigi
            andmekaitseasutusele, kus on teie alaline elukoht. Selliste asutuste
            kontaktandmed leiate aadressilt{" "}
            <a
              href="https://edpb.europa.eu/about-edpb/board/members_en"
              target="_blank"
            >
              https://edpb.europa.eu/about-edpb/board/members_en
            </a>
            .
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Vastutavate töötlejate nimekiri</Summary>
        <Details>
          <ul>
            <li>
              <strong>AS PlusPlus Capital</strong>, aadress Tartu mnt 83,
              Tallinn, 10115 Eesti, telefon +372 6224020, e-post:
              privacy[at]pluspluscapital.eu;
            </li>
            <li>
              <strong>PlusPlus Baltic OÜ</strong>, aadress Tartu mnt 83,
              Tallinn, 10115 Eesti, telefon +372 6224020, e-post:
              privacy[at]pluspluscapital.eu;
            </li>
            <li>
              <strong>PlusPlus Legal OÜ</strong>, aadress Tartu mnt 83, Tallinn,
              10115 Eesti, telefon +372 6224020, e-post:
              privacy[at]pluspluscapital.eu;
            </li>
            <li>
              <strong>
                Ārvalsts komersanta PlusPlus Baltic OU filiāle Latvijā
              </strong>
              , aadress Akmenu iela 14, Riia, LV-1048 Läti, telefon +371
              29401576, e-post: privacy[at]pluspluscapital.eu;
            </li>
            <li>
              <strong>PlusPlus Baltic OU Lietuvos filialas</strong>, aadress
              Gynėjų g. 16, Vilnius, LT-01109 Leedu, telefon +370 67490065,
              e-post: privacy[at]pluspluscapital.eu;
            </li>
            <li>
              <strong>PlusPlus Capital Oy</strong>, aadress Kasarmikatu 23 A 7,
              Helsingi, 00130 Soome, telefon+358 974790202, e-post:
              privacy[at]pluspluscapital.eu.
            </li>
          </ul>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
